import { useMemo } from 'react';
import { serviceCollectionByIdQuery } from './serviceCollectionByIdQuery';
import { useQuery, removeConnections } from 'shared/apollo';

export function useServiceCollectionByIdQuery(id) {
  const query = useQuery(serviceCollectionByIdQuery, { id });
  return useMemo(() => {
    if (!query) {
      return null;
    }
    
    const result = removeConnections(query?.allServiceCollections)?.[0];

    return {
      ...result,
      services: result?.services.map(({ dbId, name }) => ({ id: dbId, name })),
    };
  }, [query]);
}

